namespace Portico.Models.Setup {
	

    export interface IPortal {
		id: string;
		portalGroupId: string;
        name: string;
        url: string;
		beginOn: Date;
		endOn: Date;
		settings: string;
		coreVersion: string;
		createdBy: number;
		createdOn: Date;

		portalGroup: PortalGroup;
		portalChildren: PortalChild[];
		portalDataGroups: PortalDataGroup[];

		getDataRows(dataTableId: string, key?: string): DataRow[];
	}

    export class Portal implements IPortal {
		id: string;
		portalGroupId: string;
		name: string;
        url: string;
		beginOn: Date;
		endOn: Date;
		settings: string;
        coreVersion: string;
		createdBy: number;
		createdOn: Date;

		portalGroup: PortalGroup;
		portalChildren: PortalChild[];
        portalDataGroups: PortalDataGroup[];

        constructor(obj?: IPortal) {
            this.id = null;
            this.portalGroupId = null;
			this.name = null;
            this.url = null;
			this.beginOn = null;
			this.endOn = null;
			this.settings = null;
			this.coreVersion = null;
			this.createdBy = null;
			this.createdOn = null;

			this.portalGroup = null
			this.portalChildren = [];
			this.portalDataGroups = [];

            if (obj) {
                this.id = obj.id;
                this.portalGroupId = obj.portalGroupId;
				this.name = obj.name;
                this.url = obj.url;

				if (obj.beginOn) {
					this.beginOn = new Date(obj.beginOn.toString());
				}

				if (obj.endOn) {
					this.endOn = new Date(obj.endOn.toString());
				}

				this.settings = obj.settings;
				this.coreVersion = obj.coreVersion;
				this.createdBy = obj.createdBy;
				this.createdOn = obj.createdOn ? new Date(typeof obj.createdOn === 'string' && (<string>obj.createdOn).charAt(10) === 'T' ? obj.createdOn + 'Z' : obj.createdOn) : null;

				if (obj.portalGroup) {
					this.portalGroup = new PortalGroup(obj.portalGroup);
				}

				if (obj.portalChildren) {
					for (const portalChild of obj.portalChildren) {
						this.portalChildren.push(new PortalChild(portalChild));
					}
				}

				if (obj.portalDataGroups) {
					for (const portalDataGroup of obj.portalDataGroups) {
						this.portalDataGroups.push(new PortalDataGroup(portalDataGroup));
					}
				}
            }
        }

		getDataRows(dataTableId: string, key: string = null): DataRow[] {
			let dataRows: DataRow[] = [];

			for (let i = this.portalDataGroups.length - 1; i >= 0; i--) {
				const portalDataGroup = this.portalDataGroups[i];
				const temp = portalDataGroup.getDataRows(dataTableId, key);
				dataRows = dataRows.concat(temp);
			}

			return dataRows;
		}
    }
}